import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateServerPool } from "../../../actions/actionServerPool";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ServerPoolForm from "../ServerPoolForm/ServerPoolForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import AutoScale from "../../AutoScale/AutoScale";
import Servers from "../../Servers/Servers";
import Agents from "../../Agents/Agents";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "ServerPool",path:"/server_pool",isActive: false},
    {name: "UpdateServerPool",path:"/updateserver_pool",isActive: true},
];

class UpdateServerPool extends Component{
    render(){
        const pool = this.props.server_pools.find(pool => pool.server_pool_id === this.props.match.params.id)
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Pool</strong>
                                </CardHeader>
                                <ServerPoolForm
                                    updateServerPool={this.props.updateServerPool}
                                    serverPoolId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                </Row>
                {pool && pool.server_pool_type === 'Server Pool' && (
                    <Servers pool={this.props.match.params.id} />
                )}
                {pool && pool.server_pool_type === 'Docker Agent' && (
                    <Agents pool={this.props.match.params.id} />
                )}
                <AutoScale pool={this.props.match.params.id} serverPoolType={pool && pool.server_pool_type} />
            </div>
        );
    }
}

UpdateServerPool.propTypes = {
    updateServerPool: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    server_pools: state.server_pools.server_pools || []
}), 
dispatch => ({
    updateServerPool: (data) => dispatch(updateServerPool(data))
}))(UpdateServerPool);